/**
 * GBA/ITC Gateway API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CredentialDeliveryInfoDto { 
    /**
     * Primary delivery method detected from DID Document
     */
    method: CredentialDeliveryInfoDto.MethodEnum;
    /**
     * Service endpoint where credentials will be delivered
     */
    endpoint: string;
}
export namespace CredentialDeliveryInfoDto {
    export const MethodEnum = {
        DidComm: 'DIDComm',
        CredentialService: 'CredentialService',
        Email: 'Email'
    } as const;
    export type MethodEnum = typeof MethodEnum[keyof typeof MethodEnum];
}


